import { useEffect, useState } from "react";

/**
 * Read ERC-20 balances for the connected wallet on Robinhood Chain (4663).
 * Uses window.ethereum for eth_call. No web3 lib required.
 */
const RPC = process.env.REACT_APP_RH_CHAIN_RPC || "https://rpc.mainnet.chain.robinhood.com";

const TOKENS = {
  USDG: { addr: "0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168", dec: 6  },
  NVDA: { addr: "0xd0601CE157Db5bdC3162BbaC2a2C8aF5320D9EEC", dec: 18 },
  SPY:  { addr: "0x117cc2133c37B721F49dE2A7a74833232B3B4C0C", dec: 18 },
  AAPL: { addr: "0xaF3D76f1834A1d425780943C99Ea8A608f8a93f9", dec: 18 },
  TSLA: { addr: "0x322F0929c4625eD5bAd873c95208D54E1c003b2d", dec: 18 },
};

const SEL_BAL = "0x70a08231"; // balanceOf(address)

async function rpc(method, params) {
  const r = await fetch(RPC, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ jsonrpc: "2.0", id: 1, method, params }),
  });
  const j = await r.json();
  if (j.error) throw new Error(j.error.message);
  return j.result;
}

async function balanceOf(token, addr) {
  const data = SEL_BAL + addr.toLowerCase().replace("0x", "").padStart(64, "0");
  const res = await rpc("eth_call", [{ to: token.addr, data }, "latest"]);
  const raw = BigInt(res);
  return Number(raw) / 10 ** token.dec;
}

export default function useWalletBalances(rawAddress, chainId) {
  const [balances, setBalances] = useState(null);
  const [eth, setEth] = useState(null);

  useEffect(() => {
    if (!rawAddress || chainId !== 4663) {
      setBalances(null);
      setEth(null);
      return;
    }
    let stop = false;
    async function poll() {
      try {
        const [ethBal, ...rest] = await Promise.all([
          rpc("eth_getBalance", [rawAddress, "latest"]).then((h) => Number(BigInt(h)) / 1e18),
          ...Object.entries(TOKENS).map(([sym, t]) => balanceOf(t, rawAddress).then((v) => [sym, v])),
        ]);
        if (stop) return;
        setEth(ethBal);
        setBalances(Object.fromEntries(rest));
      } catch (e) {
        // swallow
      }
    }
    poll();
    const id = setInterval(poll, 12000);
    return () => { stop = true; clearInterval(id); };
  }, [rawAddress, chainId]);

  return { balances, eth };
}
